import React from 'react';
import {ExpanderView, SectionedList} from "../../components/AuditExplorer/Elements";
import {CustomFilterFrame} from "../../components/CRUDView";
import {Badge} from "reactstrap";
import {TractorOwnerRequestPaymentStatus} from "../../common/Constants";
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import Utils from "../../common/Utils";
import moment from "moment";
import ReactRating from 'react-rating';
import Icon from "react-icons-kit";
import {ic_account_balance_wallet} from 'react-icons-kit/md/ic_account_balance_wallet';
import {ic_assignment} from 'react-icons-kit/md/ic_assignment';

export const PaymentInfoView = ({ payment }) => {

    return payment && <React.Fragment>

            <CustomFilterFrame>

                <div className="text-center">
                    {payment.status === TractorOwnerRequestPaymentStatus.Success &&  <Badge pill color="success">Succeeded</Badge>}
                    {payment.status === TractorOwnerRequestPaymentStatus.Failed &&  <Badge pill color="warning">Failed</Badge>}
                    {payment.status === TractorOwnerRequestPaymentStatus.Cancelled &&  <Badge pill color="danger">Cancelled</Badge>}
                    <p><span style={{ fontSize: "3.2em" }}><NumberLabel value={payment.amount}/></span> <b>{payment.currency}</b></p>
                </div>

            </CustomFilterFrame>

            <hr/>

            <ExpanderView title={<span><i className="fa fa-money"/> Payment Info</span>} isExpanded={true}>

                <SectionedList items={[
                    {
                        title: "Reference",
                        value: payment.local_reference
                    },
                    {
                        title: "Payment Provider",
                        value: payment.payment_provider.toUpperCase()
                    },
                    {
                        title: "Amount",
                        value: <CurrencyLabel currency={payment.currency} value={payment.amount}/>
                    },
                    {
                        title: "Charges",
                        value: <CurrencyLabel currency={payment.currency} value={payment.charges}/>
                    },
                    {
                        title: "Time Issued",
                        value: Utils.formatDateStandard(payment.date_created)
                    },
                    {
                        title: "Acknowledgement Status",
                        value: payment.time_acknowledged ? <span>ACKNOWLEDGED on {moment(payment.time_acknowledged).format('L')}</span> : "NOT  ACKNOWLEDGED"
                    },
                    {
                        title: "Comments",
                        mode: "vertical",
                        value: payment.comments || "No comment"
                    }
                ]}/>

            </ExpanderView>

            <ExpanderView title={<span><Icon icon={ic_account_balance_wallet}/> Wallet</span>}>

                <SectionedList items={[
                    {
                        title: "Name",
                        value: payment.receiver_account_name
                    },
                    {
                        title: "Wallet No.",
                        value: payment.receiver_account_no
                    }
                ]}/>

            </ExpanderView>

            <ExpanderView title={<span><Icon icon={ic_assignment}/> Tractor Request Info</span>}>

                <SectionedList items={[
                    {
                        title: "Request ID",
                        value: payment.tractor_request.order_id
                    },
                    {
                        title: "Service",
                        value: payment.tractor_request.service.name
                    },
                    {
                        title: "Location",
                        value: payment.tractor_request.location
                    },
                    {
                        title: "Total Cost",
                        value: <CurrencyLabel currency={payment.tractor_request.txn_currency} value={payment.tractor_request.cost}/>
                    },
                    {
                        title: "Commission",
                        value: <CurrencyLabel currency={payment.tractor_request.txn_currency} value={payment.tractor_request.commission}/>
                    },
                    {
                        title: "Income Revenue",
                        value: <CurrencyLabel currency={payment.tractor_request.txn_currency} value={payment.tractor_request.payout}/>
                    },
                    {
                        title: "Assigned Tractor",
                        value: `${payment.tractor_request.tractor.name} (${payment.tractor_request.tractor.registration_number})`
                    },
                    {
                        title: "Driver/Operator",
                        value: payment.tractor_request.tractor_operator.name
                    },
                    {
                        title: "Rating",
                        mode: "vertical",
                        value: payment.tractor_request.operator_rating ? <ReactRating readonly
                                            emptySymbol="fa fa-star-o"
                                            fullSymbol="fa fa-star"
                                            fractions={2}
                                            initialRating={payment.tractor_request.operator_rating}/> : "NOT RATED"
                    }
                ]}/>

            </ExpanderView>

        </React.Fragment>
};


// WEBPACK FOOTER //
// ./src/views/Revenue/PaymentInfoView.js